module.exports = __webpack_public_path__ + "img/banner-1.2cc95a6d.png";